import React, { Component } from 'react';
const formatCurrency = require('format-currency');
import { getProductServicesArray } from '@src/functions/getProductServicesArray';
import Image from 'next/image';
import Link from 'next/link';
import ReactTooltip from 'react-tooltip';

class RelatedProduct extends Component {
	render() {
		const { productList, applicationSlug, provider, externalrequest } = this.props;

		if ((productList ? productList.length : 0) == 0) {
			return '';
		}
		return (
			<div className="related-products-container">
				<h6 className="section-title">Related Products</h6>
				{productList.map((item, i) => {
					var productUrl = `/product/${item.urlSlug}`;
					var hrefUrl = `/product/[productid]`;

					if (applicationSlug != undefined) {
						productUrl = `${productUrl}/${applicationSlug}`;
						hrefUrl = `${hrefUrl}/[crossreferenceid]`;
					}

					// If more services than 0, it means the product is available
					const hasServices =
						getProductServicesArray(item, 0, provider, externalrequest).serviceArray.length > 0;

					const imageUrl = item
						? item?.productPictures.length > 0
							? item.productPictures[0].imageUrl
							: null
						: null;

					// Render related product only if available
					return hasServices ? (
						<div className="product-item" key={i}>
							<Link href={hrefUrl} as={productUrl}>
								<a>
									<div className="body">
										<div
											className="img-container position-relative"
											style={{ width: '64px', height: '50px' }}>
											{imageUrl && (
												<Image
													objectFit="contain"
													layout="fill"
													src={imageUrl}
													className="lazyload"
													alt="item"
												/>
											)}
										</div>
										<div className="content-container">
											<div className="primary">
												<div className="title">
													<h5>{item.name}</h5>
													<p>{item.shortDescription}</p>
												</div>

												<div className="price">
													<h5>${formatCurrency(item.price)}</h5>
													{item.groupMessage && (
														<div className="indicator ">
															<div className="graphic">
																<i
																	style={{
																		left:
																			item.groupMessage === 'Ultimate'
																				? '85%'
																				: item.groupMessage === 'Best'
																				? '70%'
																				: item.groupMessage === 'Better'
																				? '50%'
																				: item.groupMessage === 'Good'
																				? '30%'
																				: item.groupMessage === 'Lowest'
																				? '10%'
																				: '85%',
																	}}
																	className="fas fa-triangle"></i>
																<div
																	className="square"
																	style={{
																		left:
																			item.groupMessage === 'Ultimate'
																				? '90%'
																				: item.groupMessage === 'Best'
																				? '80%'
																				: item.groupMessage === 'Better'
																				? '70%'
																				: item.groupMessage === 'Good'
																				? '60%'
																				: item.groupMessage === 'Lowest'
																				? '50%'
																				: '85%',
																	}}></div>
															</div>
															<span>{item.groupMessage ? item.groupMessage : ''}</span>
														</div>
													)}
												</div>
											</div>

											<div className="cta-buttons">
												<span className="info-available">Available</span>
											</div>
										</div>
									</div>
								</a>
							</Link>
						</div>
					) : null;
				})}
				<ReactTooltip />
			</div>
		);
	}
}

export default RelatedProduct;
